'use client';

import LoadingOverlay from '@/components/shared/loaders/LoadingOverlay';

export default function Loading() {
  // Global overlay during App Router route fetch/transition (RSC pending)
  return <LoadingOverlay />;
}

